import React from 'react';
var FORM_CONTEXT_VALUE_DEFAULT = {
  form: {
    isValid: true,
    isTouched: false,
    isInitialized: false
  },
  fields: {}
};
var FORM_CONTEXT_ACTION_DEFAULT = function FORM_CONTEXT_ACTION_DEFAULT() {};
export var FormValueContext = /*#__PURE__*/React.createContext(FORM_CONTEXT_VALUE_DEFAULT);
export var FormActionContext = /*#__PURE__*/React.createContext(FORM_CONTEXT_ACTION_DEFAULT);
export var FORM_ACTION_CHANGE = 'change';
export var FORM_ACTION_TOUCH = 'touch';
export var FORM_ACTION_INIT = 'init';
export var FORM_ACTION_SUBMIT = 'submit';
export var FORM_ACTION_RESET = 'reset';